import api from ".";
import { getToken } from "../Auth/Token";

export const addRoomNote = async (payload) => {
  try {
    const token = getToken();
    const res = await api.post("/api/workOrder/notes",
      payload, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res; 
  } catch (error) {
    console.error("Add Room Note API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getRoomNotes = async (room, date = null) => {
  try {
    const token = getToken();
    const params = new URLSearchParams({ room });
    if (date) params.append("date", date);

    const res = await api.get(`/api/workOrder/notes?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return res.data.note;
  } catch (error) {
    console.error("Get Room Notes API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};
